import React from 'react'
import { Text, Box } from 'rebass'
import styled from 'styled-components'

const Wrap = styled(Box)`
  p + p {
    margin-top: ${props => props.theme.space[3]}px;
  }

  p {
    font-family: ${props => props.theme.fonts.serif};
    font-size: 18px;
    line-height: 1.65;

    @media (min-width: ${props => props.theme.breakpoints[0]}) {
      font-size: 20px;
    }
  }
`

const TeganExcerpt = () => (
  <Wrap>
    <Text as="p">
      “Tell her to get out. Tell her to leave us the fuck alone,” Sara screamed
      as we brawled and Mom tried to separate us. “Naomi’s <em>my</em> best
      friend. Tell her to get one of her own.”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      It took all the air from inside me when Sara said it, like a bad fall.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      The summer before we started high school, Sara and I were virtually
      estranged. During the day you could find me moping in the basement of our
      baby blue two-story house, deep in the suburbs of northeast Calgary,
      watching TV alone. If I wasn’t there, I was in my room with the door
      locked, playing music so loud my ears rang. While my mom and stepdad Bruce
      were at work, Sara and I either aggressively ignored each other or were at
      each other’s throats. We fought, mercilessly, for time alone, but I still
      felt a primal fear of being apart from her, especially as high school
      loomed. I was plagued with anxiety dreams all summer, in which I wandered
      the halls of our school searching for her. The dreams stoked the dread I
      already felt, adding layers of questions I avoided in the light of day
      like I avoided Sara. We hadn’t always been like this.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      Naomi had complicated things. We met her in grade nine, our final year of
      junior high, when the French immersion program she was enrolled in moved
      to our school. Naomi was small, blond, with lively, sparkling green eyes.
      You couldn’t miss her in the halls. She dressed in brightly colored
      clothes and said hi to everyone. She oozed friendliness and kindness.
      Around her, a tight-knit pack of equally cool-looking girls we’d nicknamed
      the Frenchies was always with her. Sara and I became fast friends with all
      of them, but Naomi drew Sara and me in closest. For a time, we were both
      Naomi’s best friends. This was nothing new; Sara and I had always shared a
      best friend growing up. Our shared best friends acted as a conduit between
      us: we confessed to them what we couldn’t tell each other, and knew they’d
      pass along the message. We seemed to prefer it this way. But at the end of
      grade nine, Naomi and Sara forced an abrupt unraveling of this friendship
      after Naomi told us she and some of the other Frenchies planned to attend
      Sir Winston Churchill High School, instead of Crescent Heights, like us,
      that fall. After that, Naomi and Sara acted as if Naomi was being shipped
      overseas, rather than across town. They isolated themselves as summer
      started, hid behind the locked door of Sara’s room, and left me out of
      their plans for sleepovers. I felt confused, injured, abandoned. I
      instigated violent clashes with Sara in front of Naomi when they left me
      out, further damaging whatever bond remained between the three of us. It
      was war.
    </Text>
  </Wrap>
)

export default TeganExcerpt
